import { createRouter, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/store/user'
import Layout from '@/views/layouts/index.vue'

const router = createRouter({
  history: createWebHashHistory(), // hash模式：createWebHashHistory，history模式：createWebHistory
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/HomeNew.vue'),
      meta: {
        index: 1,
        title: ''
      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
      meta: {
        index: 1,
        title: '登录'
      }
    },
    {
      path: '/yck',
      name: 'yck',
      component: () => import(/* webpackChunkName: "yck" */ '@/views/Yck/index.vue'),
      meta: {
        index: 1,
        deposit: true,
        title: '明细'
      }
    },
    {
      path: '/yckaudit',
      name: 'yckaudit',
      component: () => import(/* webpackChunkName: "yckaudit" */ '@/views/Yck/audit.vue'),
      meta: {
        index: 1,
        deposit: true,
        title: '充值审核详情'
      }
    },
    {
      path: '/yckrecord',
      name: 'yckrecord',
      component: () => import(/* webpackChunkName: "yckrecord" */ '@/views/Yck/record.vue'),
      meta: {
        index: 1,
        deposit: true,
        title: '充值审核记录'
      }
    },
    {
      path: '/yckcz',
      name: 'yckcz',
      component: () => import(/* webpackChunkName: "yckcz" */ '@/views/Yck/cz.vue'),
      meta: {
        index: 1,
        deposit: true,
        title: '充值'
      }
    },
    {
      path: '/chooseAgent',
      name: 'chooseAgent',
      component: () => import(/* webpackChunkName: "ycktz" */ '@/views/Yck/chooseAgent.vue'),
      meta: {
        index: 1,
        deposit: true,
        title: '转赠'
      }
    },
    {
      path: '/ycktz',
      name: 'ycktz',
      component: () => import(/* webpackChunkName: "ycktz" */ '@/views/Yck/tz.vue'),
      meta: {
        index: 1,
        deposit: true,
        title: '转赠'
      }
    },
    {
      path: '/transferSuccess',
      name: 'TransferSuccess',
      component: () => import(/* webpackChunkName: "transferSuccess" */ '@/views/Yck/transferSuccess.vue'),
      meta: {
        index: 1,
        title: '转赠成功'
      }
    },
    {
      path: '/depositAuditList',
      name: 'DepositAuditList',
      component: () => import(/* webpackChunkName: "DepositAuditList" */ '@/views/Yck/depositAuditList.vue'),
      meta: { index: 1, deposit: true, title: '审核' }
    },
    {
      path: '/depositAuthDetail',
      name: 'DepositAuthDetail',
      component: () => import(/* webpackChunkName: "DepositAuthDetail" */ '@/views/Yck/depositAuthDetail.vue'),
      meta: { index: 1, deposit: true, title: '审核详情' }
    },
    {
      path: '/user',
      name: 'user',
      component: () => import(/* webpackChunkName: "user" */ '@/views/User.vue'),
      meta: {
        index: 1,
        title: '代理中心2'
      }
    },
    {
      path: '/team',
      name: 'TEAM',
      component: () => import(/* webpackChunkName: "TEAM" */ '@/views/team/teamWho.vue'),
      meta: {
        index: 1,
        title: '我的团队'
      }
    },
    {
      path: '/teamDetail',
      name: 'TEAMDETAIL',
      component: () => import(/* webpackChunkName: "TEAMDETAIL" */ '@/views/team/index.vue'),
      meta: {
        index: 1,
        title: '我的团队明细'
      }
    },
    {
      path: '/bonus',
      name: 'BONUS',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/bonus/bonusWho.vue'),
      meta: {
        index: 1,
        title: '奖金收入'
      }
    },
    {
      path: '/bonusDetail',
      name: 'BONUSDETAIL',
      component: () => import(/* webpackChunkName: "BONUSDETAIL" */ '@/views/bonus/bonusDetail.vue'),
      meta: {
        index: 1,
        title: '奖金明细'
      }
    },
    {
      path: '/promoterBonusDetail',
      name: 'PromoterBonusDetail',
      component: () => import('@/views/bonus/promoterBonusDetail.vue'),
      meta: {
        index: 1,
        title: '津贴明细'
      }
    },
    {
      path: '/wallet',
      name: 'WALLET',
      component: () => import(/* webpackChunkName: "WALLET" */ '@/views/wallet/walletWho.vue'),
      meta: {
        index: 1,
        title: '我的钱包'
      }
    },

    {
      path: '/myWallet',
      name: 'MYWALLET',
      component: () => import(/* webpackChunkName: "MYWALLET" */ '@/views/wallet/myWallet.vue'),
      meta: {
        index: 1,
        title: '我的钱包'
      }
    },
    {
      path: '/walletList',
      name: 'WalletList',
      component: () => import(/* webpackChunkName: "WALLET" */ '@/views/wallet/walletList.vue'),
      meta: {
        index: 1,
        title: '钱包列表'
      }
    },
    {
      path: '/walletDetail',
      name: 'WALLETDETAIL',
      component: () => import(/* webpackChunkName: "WALLETDETAIL" */ '@/views/wallet/walletDetail.vue'),
      meta: {
        index: 1,
        title: '钱包明细'
      }
    },
    {
      path: '/feeFreeLimit',
      name: 'FEE_FREE_LIMIT',
      component: () => import(/* webpackChunkName: "WALLETDETAIL" */ '@/views/wallet/feeFreeLimit.vue'),
      meta: {
        index: 1,
        title: '额度明细'
      }
    },
    {
      path: '/wdRecord',
      name: 'WDRECORD',
      component: () => import(/* webpackChunkName: "WDRECORD" */ '@/views/withdrawal/wdRecord.vue'),
      meta: {
        index: 1,
        title: '提现记录'
      }
    },
    {
      path: '/wdWho',
      name: 'WDWHO',
      component: () => import(/* webpackChunkName: "WDWHO" */ '@/views/withdrawal/wdWho.vue'),
      meta: {
        index: 1,
        title: '提现账户'
      }
    },
    {
      path: '/wdSuccess',
      name: 'WDSUCCESS',
      component: () => import(/* webpackChunkName: "WDSUCCESS" */ '@/views/withdrawal/wdSuccess.vue'),
      meta: {
        index: 1,
        title: '提现'
      }
    },
    {
      path: '/bank',
      name: 'BANK',
      component: () => import(/* webpackChunkName: "BANK" */ '@/views/withdrawal/bank.vue'),
      meta: {
        index: 1,
        title: '选择银行'
      }
    },
    {
      path: '/cashAdd',
      name: 'CASHADD',
      component: () => import(/* webpackChunkName: "CASHADD" */ '@/views/withdrawal/cashAdd.vue'),
      meta: {
        index: 1,
        title: '添加提现账户'
      }
    },
    {
      path: '/cash',
      name: 'CASH',
      component: () => import(/* webpackChunkName: "CASH" */ '@/views/withdrawal/cash.vue'),
      meta: {
        index: 1,
        title: '提现'
      }
    },
    {
      path: '/pwd',
      name: 'PWD',
      component: () => import(/* webpackChunkName: "PWD" */ '@/views/withdrawal/pwd.vue'),
      meta: {
        index: 1,
        title: '提现密码'
      }
    },
    {
      path: '/setPwd',
      name: 'SETPWD',
      component: () => import(/* webpackChunkName: "SETPWD" */ '@/views/withdrawal/setPwd.vue'),
      meta: {
        index: 1,
        title: '设置提现密码'
      }
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import(/* webpackChunkName: "setting" */ '@/views/Setting.vue'),
      meta: {
        index: 2,
        title: '代理中心'
      }
    },
    {
      path: '/dataStatistics',
      name: 'DataStatistics',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/data/dataStatistics.vue'),
      meta: {
        index: 1,
        title: '数据统计'
      }
    },
    {
      path: '/performance',
      name: 'Performance',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/performance/performance.vue'),
      meta: {
        index: 1,
        title: '自营数据'
      }
    },
    {
      path: '/agentRank',
      name: 'AgentRank',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/agentRank/index.vue'),
      meta: {
        index: 1,
        title: '代理排行榜'
      }
    },
    {
      path: '/agentRank/selectGoods',
      name: 'AgentRankSelectGoods',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/agentRank/selectGoods.vue'),
      meta: {
        index: 1,
        title: '选择商品'
      }
    },
    {
      path: '/agentRank/selectedGoods',
      name: 'AgentRankSelectedGoods',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/agentRank/selectedGoods.vue'),
      meta: {
        index: 1,
        title: '已选商品'
      }
    },
    {
      path: '/quasiAgentCheck',
      name: 'QuasiAgentCheck',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/quasiAgentCheck/index.vue'),
      meta: {
        index: 1,
        title: '准代理考核'
      }
    },
    {
      path: '/quasiAgentCheck/details',
      name: 'QuasiAgentCheckDetails',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/quasiAgentCheck/details.vue'),
      meta: {
        index: 1,
        title: '准代理考核详情'
      }
    },
    // 积分商城
    {
      path: '/integralShop',
      name: 'IntegralShop',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/integral/integralShop.vue'),
      meta: {
        index: 1,
        title: '',
        defTitle: '积分商城'
      }
    },
    {
      path: '/integral',
      name: 'Integral',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/integral/index.vue'),
      meta: {
        index: 1,
        title: '',
        defTitle: '积分中心'
      }
    },
    {
      path: '/integral/integralUsed',
      name: 'IntegralUsed',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/integral/index.vue'),
      props: { isUsedOfPage: true },
      meta: {
        index: 1,
        title: '',
        defTitle: '已使用积分'
      }
    },
    {
      path: '/exchangeStore',
      name: 'ExchangeStore',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/coupon/exchangeStore.vue'),
      meta: {
        index: 1,
        title: '兑换专区'
      }
    },
    {
      path: '/myExchangeCoupon',
      name: 'MyExchangeCoupon',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/coupon/myExchangeCoupon.vue'),
      meta: {
        index: 1,
        title: '我的兑换券'
      }
    },
    {
      path: '/exchangeCouponRecord',
      name: 'ExchangeCouponRecord',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/coupon/exchangeCouponRecord.vue'),
      meta: {
        index: 1,
        title: '兑换券记录'
      }
    },
    {
      path: '/myCheck',
      name: 'MyCheck',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/myCheck/index.vue'),
      meta: {
        index: 1,
        title: '我的考核'
      }
    },
    {
      path: '/brisk',
      name: 'Brisk',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/brisk/index.vue'),
      meta: {
        index: 1,
        title: '活跃值'
      }
    },
    {
      path: '/brisk/briskDetails',
      name: 'BriskDetails',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/brisk/briskDetails.vue'),
      meta: {
        index: 1,
        title: '活跃值明细'
      }
    },
    {
      path: '/brisk/briskRank',
      name: 'BriskRank',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/brisk/briskRank.vue'),
      meta: {
        index: 1,
        title: '活跃值排行'
      }
    },
    {
      path: '/brisk/briskUploadGroupPic',
      name: 'BriskUploadGroupPic',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/brisk/briskUploadGroupPic.vue'),
      meta: {
        index: 1,
        title: '上传群截图'
      }
    },
    {
      path: '/brisk/briskGroupPicCheckStatus',
      name: 'BriskGroupPicCheckStatus',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/brisk/briskGroupPicCheckStatus.vue'),
      meta: {
        index: 1,
        title: '群截图'
      }
    },
    {
      path: '/myFans',
      name: 'MyFans',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/myFans/index.vue'),
      meta: {
        index: 1,
        title: '我的粉丝'
      }
    },
    {
      path: '/coupon',
      name: 'Coupon',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/coupon/index.vue'),
      meta: {
        index: 1,
        title: '领券中心'
      }
    },
    {
      path: '/couponList',
      name: 'CouponList',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/coupon/couponList.vue'),
      meta: {
        index: 1,
        title: '优惠券'
      }
    },
    {
      path: '/couponDetails',
      name: 'CouponDetails',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/coupon/couponDetails.vue'),
      meta: {
        index: 1,
        title: '优惠券详情'
      }
    },
    {
      path: '/couponGoodsList',
      name: 'CouponGoodsList',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/coupon/couponGoodsList.vue'),
      meta: {
        index: 1,
        title: '优惠券'
      }
    },
    {
      path: '/applySharer',
      name: 'ApplySharer',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/applySharer/index.vue'),
      meta: {
        index: 1,
        title: '申请成为分享员'
      }
    },
    {
      path: '/bindSharer',
      name: 'BindSharer',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/applySharer/bindSharer.vue'),
      meta: {
        index: 1,
        title: '邀请二维码'
      }
    },
    {
      path: '/shopCertification',
      name: 'ShopCertification',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/ShopCertification.vue'),
      meta: {
        index: 1,
        title: '店铺资质'
      }
    },
    {
      path: '/liveDuration',
      name: 'LiveDuration',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/live/liveDuration.vue'),
      meta: {
        index: 1,
        title: '观看时长'
      }
    },
    {
      path: '/liveWatchSts',
      name: 'LiveWatchSts',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/live/liveWatchSts.vue'),
      meta: {
        index: 1,
        title: '观看统计'
      }
    },
    {
      path: '/insurance',
      name: 'Insurance',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/insurance.vue'),
      meta: {
        index: 1,
        title: '退换无忧详情'
      }
    },
    {
      path: '/state',
      name: 'State',
      component: () => import(/* webpackChunkName: "BONUS" */ '@/views/state/index.vue'),
      meta: {
        index: 1,
        title: '说明'
      }
    },
    {
      path: '/store/writeOffRecord',
      name: 'WriteOffRecord',
      component: () => import('@/views/store/writeOffRecord/index.vue'),
      meta: { index: 1, title: '核销记录' }
    },
    {
      path: '/relations',
      name: 'Relations',
      component: () => import('@/views/relations/relations.vue'),
      meta: { index: 1, title: '关系链查询' }
    },
    {
      path: '/goodsPayment',
      name: 'GoodsPayment',
      component: Layout,
      redirect: '/goodsPayment/paymentAccount',
      children: [
        {
          path: 'paymentAccount',
          name: 'PaymentAccount',
          component: () => import('@/views/goodsPayment/paymentAccount.vue'),
          meta: { title: '货款账户' }
        },
        {
          path: 'accountDetail',
          name: 'AccountDetail',
          component: () => import('@/views/goodsPayment/accountDetail.vue'),
          meta: { title: '账户明细' }
        },
        {
          path: 'cashRecord',
          name: 'CashRecord',
          component: () => import('@/views/goodsPayment/cashRecord.vue'),
          meta: { title: '提现记录' }
        },
        {
          path: 'goodsPaymentRecord',
          name: 'GoodsPaymentRecord',
          component: () => import('@/views/goodsPayment/goodsPaymentRecord.vue'),
          meta: { title: '货款记录' }
        }
      ]
    },
    {
      path: '/upgrade',
      name: 'Upgrade',
      component: () => import('@/views/upgrade/index.vue'),
      meta: { index: 1, title: '我要升级' }
    },
    {
      path: '/bailList',
      name: 'BailList',
      component: () => import('@/views/upgrade/bailList.vue'),
      meta: { index: 2, title: '保证金明细' }
    },
    {
      path: '/teamReward',
      name: 'TeamReward',
      component: () => import('@/views/upgrade/teamReward.vue'),
      meta: { index: 1, title: '团队业绩奖' }
    },
    {
      path: '/regionalReward',
      name: 'RegionalReward',
      component: () => import('@/views/upgrade/regionalReward.vue'),
      meta: { index: 1, title: '区域分红奖' }
    },
    {
      path: '/regionalReward/detail',
      name: 'RegionalRewardDetail',
      component: () => import('@/views/upgrade/regionalRewardDetail.vue'),
      meta: { index: 1, title: '区域分红奖' }
    },
    {
      path: '/goodsStatistics',
      name: 'GoodsStatistics',
      component: Layout,
      redirect: '/goodsStatistics',
      children: [
        {
          path: '',
          name: 'Index',
          component: () => import('@/views/goodsStatistics/index.vue'),
          meta: { title: '商品统计' }
        },
        {
          path: 'salesVolumeDetail',
          name: 'salesVolumeDetail',
          component: () => import('@/views/goodsStatistics/salesVolumeDetail.vue'),
          meta: { title: '销量明细' }
        },
        {
          path: 'salesVolumePank',
          name: 'salesVolumePank',
          component: () => import('@/views/goodsStatistics/salesVolumePank.vue'),
          meta: { title: '订单明细' }
        }
      ]
    },
    {
      path: '/invoiceNotice',
      name: 'InvoiceNotice',
      component: () => import('@/views/withdrawal/invoiceNotice.vue'),
      meta: { title: '开票教程' }
    }
  ]
})

// 仅预存款相关页面（meta.deposit）用动态别称拼接标题；其余页面沿用 App.vue 中的默认标题逻辑
router.afterEach(to => {
  if (to.meta && to.meta.deposit) {
    document.title = useUserStore().getDepositName + (to.meta.title || '')
  }
})

export default router
